import { usePathname, useRouter, useSearchParams } from 'next/navigation';

const useSearchNavigation = () => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  const handleTabChange = (item: string) => {
    const params = new URLSearchParams(searchParams);
    params.set('scope', item);
    router.push(`${pathname}?${params.toString()}`);
  };

  return { handleTabChange };
};

export default useSearchNavigation;
